import { render, staticRenderFns } from "./myWrongQuestion.vue?vue&type=template&id=08ccdef1&scoped=true"
import script from "./myWrongQuestion.vue?vue&type=script&lang=js"
export * from "./myWrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./myWrongQuestion.vue?vue&type=style&index=0&id=08ccdef1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccdef1",
  null
  
)

export default component.exports